
import Redirect from '@/shared/utils/redirect.util';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  public exibeMenu = false;

  public nomeUsuarioLogado = 'Adm';

  public cpfLogado = '';

  public items: Array<any> = [
    {
      title: 'Cupom',
      icon: 'mdi-view-dashboard',
      link: '/cupom',
    },
    {
      title: 'Produto',
      icon: 'mdi-forum',
      link: '/produto',
    },
    {
      title: 'Equipamento',
      icon: 'mdi-forum',
      link: '/equipamento',
    },
    {
      title: 'Monitoramento',
      icon: 'mdi-forum',
      link: '/monitoramento',
    },
    {
      title: 'Usuário (APP)',
      icon: 'mdi-forum',
      link: '/usuario-app',
    },
    {
      title: 'Regras',
      icon: 'mdi-forum',
      link: '/regras',
    },
    {
      title: 'Canal',
      icon: 'mdi-forum',
      link: '/canal',
    },
    {
      title: 'Posto de Troca',
      icon: 'mdi-forum',
      link: '/posto-troca',
    },
    {
      title: 'Perguntas (Game Heineken)',
      icon: 'mdi-forum',
      link: '/pergunta',
    },
    {
      title: 'Usuário Administrativo',
      icon: 'mdi-forum',
      link: '/usuario-administrativo',
    },
    {
      title: 'Notificação',
      icon: 'mdi-forum',
      link: '/notificacao',
    },
    {
      title: 'Relatórios',
      icon: 'mdi-forum',
      link: '/relatorios',
    },
    {
      title: 'Regra Transferência',
      icon: 'mdi-forum',
      link: '/regra-tranferencia',
    },
  ];

  validarRotas() {
    // TODO: IMPLEMENTANDO NO HARDCODE PROVISÓRIAMENTE ATÉ A IMPLEMENTAÇÃO DO BACK-END.
    if (localStorage.getItem('cpf') === '05220997696') {
      this.items.splice(0);
      this.items.unshift({
        title: 'Monitoramento',
        icon: 'mdi-forum',
        link: '/monitoramento',
      });
    }
    return this.items;
  }

  private deslogar() {
    Redirect.deslogar(this);
  }

  mounted() {
    this.items = this.validarRotas();
  }

  created() {
    this.nomeUsuarioLogado = localStorage.nome;
  }
}
